import { ISurveyTemplateElementGroupData } from './ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from './ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from './ISurveyTemplateUnitData';

export function isSurveyTemplateManifestationData(
    data: ISurveyTemplateUnitData | ISurveyTemplateElementGroupData | ISurveyTemplateManifestationData,
): data is ISurveyTemplateManifestationData {
    return (data as ISurveyTemplateManifestationData).manifestationId !== undefined;
}
